class CustomPredictiveSearchSKU {
  constructor(form) {
    this.form = form;
    this.input = form.querySelector('.custom-search__input');
    this.results = form.querySelector('.custom-search__results');
    this.abortController = null;

    this.bindEvents();
  }

  bindEvents() {
    this.input.addEventListener('input', this.onInput.bind(this));
    this.input.addEventListener('keydown', this.onKeyDown.bind(this));
    document.addEventListener('click', this.onOutsideClick.bind(this));
  }

  async onInput() {
    const query = this.input.value.trim().toLowerCase();

    if (query.length < 1) {
      this.hideResults();
      return;
    }

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    try {
      // Fetch products
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=20`,
        { signal: this.abortController.signal }
      );

      const data = await response.json();
      let products = data.resources.results.products || [];

      // Filter by SKU or title
      products = products.filter(product =>
        (product.sku && product.sku.toLowerCase().includes(query)) ||
        (product.title && product.title.toLowerCase().includes(query))
      );

      this.renderResults(products, query);
    } catch (e) {
      if (e.name !== 'AbortError') console.error(e);
    }
  }

  highlightMatch(text, query) {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, 'gi');
    return text.replace(regex, '<strong>$1</strong>');
  }

  renderResults(products, query) {
    if (!products.length) {
      this.hideResults();
      return;
    }

this.results.innerHTML = products
  .map(product => {
    const title = this.highlightMatch(product.title, query);
    const sku = product.sku ? this.highlightMatch(product.sku, query) : '';

    const priceValue = product.price || (product.variants && product.variants[0]?.price) || product.price_min || 0;
    const price = `$${parseFloat(priceValue).toFixed(2)}`;

    return `
      <a href="${product.url}" class="custom-search__item">
        <img class="custom-search__image" src="${product.image}" alt="">
        <div>
          <div>${title}</div>
          ${sku ? `<div class="custom-search__sku">${sku}</div>` : ''}
          <div class="custom-search__price">${price}</div>
        </div>
      </a>
    `;
  })
  .join('');
    this.results.hidden = false;
  }

  hideResults() {
    this.results.hidden = true;
  }

  onOutsideClick(e) {
    if (!this.form.contains(e.target)) {
      this.hideResults();
    }
  }

  onKeyDown(e) {
    const items = Array.from(this.results.querySelectorAll('a'));
    if (!items.length) return;

    const active = this.results.querySelector('.active');
    let index = items.indexOf(active);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (index < items.length - 1) index++;
      else index = 0;
      this.setActive(items, index);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (index > 0) index--;
      else index = items.length - 1;
      this.setActive(items, index);
    } else if (e.key === 'Enter') {
      if (active) {
        window.location.href = active.href;
        e.preventDefault();
      }
    }
  }

  setActive(items, index) {
    items.forEach(i => i.classList.remove('active'));
    items[index].classList.add('active');
    items[index].scrollIntoView({ block: 'nearest' });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('.custom-search')
    .forEach(form => new CustomPredictiveSearchSKU(form));
});
